import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * P1-B — Low-reports banner (the component name keeps "Credit": it is an
 * identifier, not copy). Shown when at most 1 analysis report is left and the
 * org is not on an unlimited plan. Renders nothing otherwise. It mostly shows
 * to trial orgs.
 *
 * KG이니시스 review (2026-10-02, Portone-KGinisys-Pricing-fix-10-2.md T2.3):
 * no "충전" / "top up" — nothing can be bought — and no "약": one report uses
 * exactly one, so the count is exact. "이번 달" only when `monthly` (the
 * server's `tier_grants_monthly`) is true; it defaults to false.
 */
export default function LowCreditBanner({ balance, isUnlimited, isAdmin, monthly = false }) {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  if (isUnlimited || isAdmin) return null;
  if (balance === null || balance === undefined) return null;
  if (balance > 1) return null;

  const isExhausted = balance <= 0;
  const text = isKo
    ? (isExhausted
        ? (monthly ? '⚠ 이번 달 제공된 분석 리포트를 모두 이용하셨습니다.' : '⚠ 제공된 분석 리포트를 모두 이용하셨습니다.')
        : `⚠ ${monthly ? '이번 달 ' : ''}남은 분석 리포트 ${balance}건`)
    : (isExhausted
        ? (monthly ? "⚠ You've used all of this month's analysis reports." : "⚠ You've used all of your analysis reports.")
        : `⚠ ${balance} analysis report${balance === 1 ? '' : 's'} left${monthly ? ' this month' : ''}`);

  return (
    <div
      style={{
        background: '#FEF3C7',
        borderLeft: '3px solid #D97706',
        color: '#92400E',
        padding: '10px 16px',
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        fontSize: 13,
        flexWrap: 'wrap',
      }}
    >
      <span style={{ fontWeight: 500 }}>{text}</span>
      <Link
        to="/settings?tab=subscription"
        style={{
          color: '#92400E',
          fontWeight: 700,
          textDecoration: 'underline',
          fontSize: 13,
        }}
      >
        {isKo ? '플랜 보기' : 'View plan'}
      </Link>
    </div>
  );
}
